const ISBNUtils = {
    /**
     * ISBN10をハイフン無しのISBN13へ変換する。
     * 変換できなかった場合はnullを返す。
     * @param isbn10
     * @returns {string|null}
     */
    isbn10to13: function(isbn10) {
        // 先頭BのASINを除外する
        if (!isbn10 || isbn10.slice(0, 1) === "B"){
            return null;
        }
        // 1. 先頭に`978`を足して、末尾の1桁を除く
        const src = `978${isbn10.slice(0, 9)}`;

        // 2. 先頭の桁から順に1、3、1、3…を掛けて合計する
        const sum = src.split('').map(s => parseInt(s))
            .reduce((p, c, i) => p + ((i % 2 === 0) ? c : c * 3));

        // 3. 合計を10で割った余りを10から引く（※引き算の結果が10の時は0とする）
        const rem = 10 - sum % 10;
        const checkdigit = rem === 10 ? 0 : rem;

        // 1.の末尾に3.の値を添えて出来上がり
        return `${src}${checkdigit}`;
    }
}
export default ISBNUtils;